import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import FormGroup from "react-bootstrap/lib/FormGroup";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import FormControl from "react-bootstrap/lib/FormControl";
import InputGroup from "react-bootstrap/lib/InputGroup";
import Button from "react-bootstrap/lib/Button";

import updateStep3 from "./updateStep3";
import FooterButton from "./FooterButton";
import SidePanel from "./SidePanel";
import InputFieldComponent from "../Common/FormField/InputFieldComponent";
import SelectFieldComponent from "../Common/FormField/SelectFieldComponent";
import IncrementButton from "../IncrementButton";
import CustomCheckbox from "../CustomCheckbox";

import messages from "../../locale/messages";
import validateStep3 from "./validateStep3";
import { normalizePrice } from "../../helpers/normalizePrice";

import toolTipIcon from "/public/SiteIcons/listCommonToolTip.svg";

import bt from "../../components/commonStyle.css";
import s from "./ListPlaceStep1.css";
import { DecrementIcon } from "../Common/Assets/SvgComponent/commonSvgIcon";

class Pricing extends Component {
    static propTypes = {
        previousPage: PropTypes.any,
        nextPage: PropTypes.any,
    };

    constructor(props) {
        super(props);
        this.state = {
            isDisabled: true,
            personCapacity: {
                itemName: null,
                otherItemName: null,
                startValue: 0,
                endValue: 0,
            },
            customDiscounts: [],
        };
    }

    // Wrapper for CustomCheckbox to work with redux-form Field
    renderCheckboxField = ({ input, label, className, containerClassName }) => (
        <CustomCheckbox
            name={input.name}
            className={className}
            containerClassName={containerClassName}
            label={label}
            checked={input.value === true}
            onChange={(checked) => input.onChange(checked)}
        />
    );

    UNSAFE_componentWillMount() {
        const { valid, listingFields, customDiscounts } = this.props;
        this.setState({ isDisabled: valid ? false : true });

        if (listingFields != undefined) {
            this.setState({
                personCapacity: listingFields.personCapacity[0],
            });
        }

        // Load existing custom discounts
        if (customDiscounts) {
            try {
                const parsedDiscounts = JSON.parse(customDiscounts);
                this.setState({ customDiscounts: parsedDiscounts });
            } catch (e) {
                console.log("Error parsing customDiscounts:", e);
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { valid, listingFields, customDiscounts } = nextProps;
        this.updateFormValidation(valid);

        if (listingFields != undefined) {
            this.setState({
                personCapacity: listingFields.personCapacity[0],
            });
        }

        // Load existing custom discounts when props change
        if (customDiscounts && customDiscounts !== this.props.customDiscounts) {
            try {
                const parsedDiscounts = JSON.parse(customDiscounts);
                this.setState({ customDiscounts: parsedDiscounts }, () => {
                    this.updateFormValidation(valid);
                });
            } catch (e) {
                console.log("Error parsing customDiscounts:", e);
            }
        }
    }

    renderIncrementButton = (field) => <IncrementButton {...field} />;

    validateCustomDiscounts = () => {
        const { customDiscounts } = this.state;
        return customDiscounts.every((discount) => {
            // If any field is filled, all fields must be filled
            const hasAnyField =
                discount.periodType ||
                discount.periodValue ||
                discount.discountPercentage;
            const hasAllFields =
                discount.periodType &&
                discount.periodValue &&
                discount.discountPercentage;

            return !hasAnyField || hasAllFields;
        });
    };

    updateFormValidation = (reduxFormValid) => {
        const customDiscountsValid = this.validateCustomDiscounts();
        this.setState({
            isDisabled: !(reduxFormValid && customDiscountsValid),
        });
    };

    renderFormControlTax = ({
        input,
        label,
        type,
        meta: { touched, error },
        className,
        prefixLabel,
    }) => {
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <InputGroup>
                    <FormControl
                        {...input}
                        placeholder={label}
                        type={type}
                        className={className}
                        maxLength={12}
                    />
                    <InputGroup.Addon className={s.prefixIcon}>
                        {prefixLabel}
                    </InputGroup.Addon>
                </InputGroup>
                {touched && error && (
                    <span className={s.errorMessage}>
                        {formatMessage(error)}
                    </span>
                )}
            </div>
        );
    };

    renderFormControlSelect = ({
        input,
        label,
        meta: { touched, error },
        children,
        className,
    }) => {
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <FormControl
                    componentClass="select"
                    {...input}
                    className={className}
                >
                    {children}
                </FormControl>
            </div>
        );
    };

    addCustomDiscount = () => {
        const { customDiscounts } = this.state;
        const updatedDiscounts = [
            ...customDiscounts,
            { periodType: "", periodValue: "", discountPercentage: "" },
        ];
        this.setState(
            {
                customDiscounts: updatedDiscounts,
            },
            () => {
                this.updateFormValidation(this.props.valid);
                // Update Redux Form field
                this.props.change(
                    "customDiscounts",
                    JSON.stringify(updatedDiscounts)
                );
            }
        );
    };

    removeCustomDiscount = (index) => {
        const { customDiscounts } = this.state;
        const updatedDiscounts = customDiscounts.filter((_, i) => i !== index);
        this.setState({ customDiscounts: updatedDiscounts }, () => {
            this.updateFormValidation(this.props.valid);
            // Update Redux Form field
            this.props.change(
                "customDiscounts",
                JSON.stringify(updatedDiscounts)
            );
        });
    };

    updateCustomDiscount = (index, field, value) => {
        const { customDiscounts } = this.state;
        const updatedDiscounts = [...customDiscounts];
        updatedDiscounts[index] = {
            ...updatedDiscounts[index],
            [field]: value,
        };
        this.setState({ customDiscounts: updatedDiscounts }, () => {
            this.updateFormValidation(this.props.valid);
            // Update Redux Form field
            this.props.change(
                "customDiscounts",
                JSON.stringify(updatedDiscounts)
            );
        });
    };

    updateCustomDiscountBoth = (index, periodType, periodValue) => {
        const { customDiscounts } = this.state;
        const updatedDiscounts = [...customDiscounts];
        updatedDiscounts[index] = {
            ...updatedDiscounts[index],
            periodType,
            periodValue,
        };
        this.setState({ customDiscounts: updatedDiscounts }, () => {
            this.updateFormValidation(this.props.valid);
            // Update Redux Form field
            this.props.change(
                "customDiscounts",
                JSON.stringify(updatedDiscounts)
            );
        });
    };

    renderCustomDiscounts = () => {
        const { customDiscounts } = this.state;
        const { formatMessage } = this.props.intl;

        const periodOptions = [
            { value: "nights:2", label: formatMessage(messages.nights2) },
            { value: "nights:3", label: formatMessage(messages.nights3) },
            { value: "nights:4", label: formatMessage(messages.nights4) },
            { value: "nights:5", label: formatMessage(messages.nights5) },
            { value: "weeks:1", label: formatMessage(messages.week1) },
            { value: "weeks:2", label: formatMessage(messages.weeks2) },
            { value: "months:1", label: formatMessage(messages.month1) },
        ];

        // Get already selected durations
        const getSelectedDurations = () => {
            return customDiscounts
                .filter(
                    (discount) => discount.periodType && discount.periodValue
                )
                .map(
                    (discount) =>
                        `${discount.periodType}:${discount.periodValue}`
                );
        };

        return (
            <div className={s.spaceTop4}>
                <hr className={s.horizontalLineThrough} />
                <FormGroup className={cx(s.formGroup, s.space4)}>
                    <ControlLabel className={cx(s.landingLabel)}>
                        <FormattedMessage {...messages.customDiscounts} />
                    </ControlLabel>
                    <div className={s.tipCommonCss}>
                        <img src={toolTipIcon} />
                        <span className={cx(s.commonTipCsss)}>
                            <FormattedMessage
                                {...messages.customDiscountsTip}
                            />
                        </span>
                    </div>
                </FormGroup>

                {customDiscounts.map((discount, index) => {
                    const selectedDurations = getSelectedDurations();
                    const currentSelection =
                        discount.periodType && discount.periodValue
                            ? `${discount.periodType}:${discount.periodValue}`
                            : "";

                    return (
                        <div
                            key={index}
                            className={cx(s.formGroup, s.space4)}
                            style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "flex-end",
                            }}
                        >
                            <div style={{ flex: 2 }}>
                                <ControlLabel className={cx(s.landingLabel)}>
                                    <FormattedMessage
                                        {...messages.discountPeriod}
                                    />
                                </ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    value={
                                        discount.periodType &&
                                        discount.periodValue
                                            ? `${discount.periodType}:${discount.periodValue}`
                                            : ""
                                    }
                                    onChange={(e) => {
                                        if (e.target.value === "") {
                                            this.updateCustomDiscountBoth(
                                                index,
                                                "",
                                                ""
                                            );
                                        } else {
                                            const [type, value] =
                                                e.target.value.split(":");

                                            this.updateCustomDiscountBoth(
                                                index,
                                                type,
                                                parseInt(value)
                                            );
                                        }
                                    }}
                                    className={cx(
                                        bt.commonControlSelect,
                                        "commonControlSelectRtl"
                                    )}
                                >
                                    <option value="">
                                        {formatMessage(messages.selectPeriod)}
                                    </option>
                                    {periodOptions.map((option) => {
                                        const isDisabled =
                                            selectedDurations.includes(
                                                option.value
                                            ) &&
                                            option.value !== currentSelection;
                                        return (
                                            <option
                                                key={option.value}
                                                value={option.value}
                                                disabled={isDisabled}
                                            >
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </FormControl>
                            </div>
                            <div style={{ flex: 1 }}>
                                <ControlLabel className={cx(s.landingLabel)}>
                                    <FormattedMessage
                                        {...messages.discountPercentage}
                                    />
                                </ControlLabel>
                                <input
                                    type="text"
                                    value={discount.discountPercentage}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === "") {
                                            this.updateCustomDiscount(
                                                index,
                                                "discountPercentage",
                                                ""
                                            );
                                        } else {
                                            const numValue = parseFloat(value);
                                            if (
                                                !isNaN(numValue) &&
                                                numValue >= 0 &&
                                                numValue <= 99
                                            ) {
                                                this.updateCustomDiscount(
                                                    index,
                                                    "discountPercentage",
                                                    numValue
                                                );
                                            }
                                        }
                                    }}
                                    className={bt.commonControlInput}
                                    placeholder="0"
                                    min="0"
                                    max="99"
                                />
                            </div>
                            <div style={{ flex: 0 }}>
                                <Button
                                    className={cx(s.btnWidth)}
                                    onClick={() =>
                                        this.removeCustomDiscount(index)
                                    }
                                    type="button"
                                    style={{
                                        height: "58px",
                                        backgroundColor:
                                            "var(--error-color, #dc3545)",
                                        borderColor:
                                            "var(--error-color, #dc3545)",
                                        minWidth: "58px",
                                        padding: "0",
                                        color: "#fff",
                                    }}
                                >
                                    <DecrementIcon />
                                </Button>
                            </div>
                        </div>
                    );
                })}

                <FormGroup className={cx(s.formGroup, s.space4)}>
                    <Button
                        className={cx(bt.btnPrimaryBorder, s.btnWidth)}
                        onClick={this.addCustomDiscount}
                        type="button"
                    >
                        + <FormattedMessage {...messages.addDiscountRule} />
                    </Button>
                </FormGroup>
            </div>
        );
    };

    render() {
        const {
            handleSubmit,
            nextPage,
            previousPage,
            formPage,
            step,
            availableCurrencies,
            personCapacityValue,
            weekendPriceValue,
        } = this.props;
        const { isDisabled, personCapacity, customDiscounts } = this.state;
        const { formatMessage } = this.props.intl;

        let currencyValue = [];

        availableCurrencies?.length > 0 &&
            availableCurrencies.map((currency, key) => {
                if (currency.isEnable === true) {
                    currencyValue.push({
                        value: currency.symbol,
                        label: currency.symbol,
                    });
                }
            });

        return (
            <div className={s.grid}>
                <SidePanel
                    title={formatMessage(messages.stepThreeCommonHeading)}
                    landingContent={formatMessage(messages.tabPricing)}
                />
                <form onSubmit={handleSubmit}>
                    <div className={cx(s.landingMainContent, "disCountAddon")}>
                        <FormGroup className={s.formGroup}>
                            <Field
                                name="currency"
                                label={formatMessage(messages.currency)}
                                labelClass={cx(s.landingLabel)}
                                component={SelectFieldComponent}
                                inputClass={cx(
                                    bt.commonControlSelect,
                                    "commonControlSelectRtl"
                                )}
                                options={currencyValue}
                            />
                        </FormGroup>
                        <FormGroup
                            className={cx(s.formGroup, s.space4, s.spaceTop4)}
                        >
                            <ControlLabel className={cx(s.landingLabel)}>
                                <FormattedMessage {...messages.basePrice} />
                            </ControlLabel>
                            <Field
                                name="basePrice"
                                type="text"
                                component={InputFieldComponent}
                                placeholder={formatMessage(
                                    messages.basePriceLabel
                                )}
                                inputClass={bt.commonControlInput}
                                normalize={normalizePrice}
                            />
                        </FormGroup>
                        <div className={s.tipCommonCss}>
                            <img src={toolTipIcon} />
                            <span className={cx(s.commonTipCsss)}>
                                <FormattedMessage {...messages.basePriceTip} />
                            </span>
                        </div>

                        {/* Weekend Pricing Section */}
                        <div className={s.spaceTop4}>
                            <hr className={s.horizontalLineThrough} />
                            <FormGroup className={cx(s.formGroup, s.space4)}>
                                <ControlLabel className={cx(s.landingLabel)}>
                                    <FormattedMessage
                                        {...messages.weekendPrice}
                                    />
                                </ControlLabel>
                                <Field
                                    name="weekendPrice"
                                    type="text"
                                    component={InputFieldComponent}
                                    placeholder={formatMessage(
                                        messages.weekendPriceLabel
                                    )}
                                    inputClass={bt.commonControlInput}
                                    normalize={normalizePrice}
                                />
                            </FormGroup>

                            {/* Minimum Stay Weekend Checkbox - Only shown when weekendPrice has a value */}
                            {(weekendPriceValue && parseFloat(weekendPriceValue) > 0) && (
                                <FormGroup className={cx(s.formGroup, s.space4)}>
                                    <Field
                                        name="minStayWeekend"
                                        component={this.renderCheckboxField}
                                        className='commonCustomCheckBox'
                                        containerClassName={cx(s.houseRulesList, 'commonCustomCheckFlex')}
                                        label={formatMessage(messages.minStayWeekend)}
                                    />
                                </FormGroup>
                            )}
                        </div>

                        <FormGroup className={cx(s.formGroup, s.space4)}>
                            <ControlLabel className={cx(s.landingLabel)}>
                                <FormattedMessage {...messages.cleaningPrice} />
                            </ControlLabel>
                            <Field
                                name="cleaningPrice"
                                type="text"
                                component={InputFieldComponent}
                                placeholder={formatMessage(
                                    messages.cleaningPrice
                                )}
                                inputClass={bt.commonControlInput}
                                normalize={normalizePrice}
                            />
                        </FormGroup>
                        {/*<FormGroup className={cx(s.formGroup, s.space4)}>
                            <ControlLabel className={cx(s.landingLabel)}>
                                <FormattedMessage {...messages.tax} />
                            </ControlLabel>
                            <Field
                                name="tax"
                                type="text"
                                component={InputFieldComponent}
                                placeholder={formatMessage(messages.tax)}
                                inputClass={bt.commonControlInput}
                                prefixLabel={"%"}
                                isAddon={true}
                                normalize={normalizePrice}
                            />
                        </FormGroup>*/}
                        <FormGroup className={cx(s.formGroup, s.space4)}>
                            <ControlLabel className={cx(s.landingLabel)}>
                                <FormattedMessage
                                    {...messages.cautionDeposit}
                                />
                            </ControlLabel>
                            <Field
                                name="cautionDeposit"
                                type="text"
                                component={InputFieldComponent}
                                placeholder={formatMessage(
                                    messages.cautionDepositPlaceholder
                                )}
                                inputClass={bt.commonControlInput}
                                normalize={normalizePrice}
                            />
                        </FormGroup>

                        {/* Extra Guest Pricing Section */}
                        <div className={s.spaceTop4}>
                            <hr className={s.horizontalLineThrough} />
                            <FormGroup className={cx(s.formGroup, s.space4)}>
                                <ControlLabel className={cx(s.landingLabel)}>
                                    <FormattedMessage
                                        {...messages.extraGuestThreshold}
                                    />
                                </ControlLabel>
                                <Field
                                    name="extraGuestThreshold"
                                    component={this.renderIncrementButton}
                                    labelSingluar={personCapacity.itemName}
                                    labelPlural={personCapacity.otherItemName}
                                    maxValue={
                                        personCapacityValue ||
                                        personCapacity.endValue
                                    }
                                    minValue={0}
                                    incrementBy={1}
                                    format={(value) => value || 0}
                                    normalize={(value) => value || 0}
                                />
                            </FormGroup>
                            <FormGroup className={cx(s.formGroup, s.space4)}>
                                <ControlLabel className={cx(s.landingLabel)}>
                                    <FormattedMessage
                                        {...messages.extraGuestFee}
                                    />
                                </ControlLabel>
                                <Field
                                    name="extraGuestFee"
                                    type="text"
                                    placeholder={formatMessage(
                                        messages.extraGuestFeePlaceholder
                                    )}
                                    component={InputFieldComponent}
                                    inputClass={bt.commonControlInput}
                                    normalize={normalizePrice}
                                />
                            </FormGroup>
                        </div>


                        {/* Hidden field to store customDiscounts in Redux Form */}
                        <Field
                            name="customDiscounts"
                            component="input"
                            type="hidden"
                            value={JSON.stringify(this.state.customDiscounts)}
                        />
                    </div>
                    <FooterButton
                        nextPage={nextPage}
                        previousPage={previousPage}
                        nextPagePath={"discount"}
                        previousPagePath={"advance-notice"}
                        formPage={formPage}
                        step={step}
                        isDisabled={isDisabled}
                    />
                </form>
            </div>
        );
    }
}

Pricing = reduxForm({
    form: "ListPlaceStep3", // a unique name for this form
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate: validateStep3,
    onSubmit: updateStep3,
    // onSubmit: updateStep4
})(Pricing);

// Form selector to get personCapacity value from ListPlaceStep1 form
const selectorStep1 = formValueSelector("ListPlaceStep1");
// Form selector to get customDiscounts value from ListPlaceStep3 form
const selectorStep3 = formValueSelector("ListPlaceStep3");

const mapState = (state) => ({
    listingFields: state.listingFields.data,
    availableCurrencies: state?.currency?.availableCurrencies?.results,
    base: state.currency.base,
    mapUpdateLoading: state.location.mapUpdateLoading,
    personCapacityValue: selectorStep1(state, "personCapacity"),
    customDiscounts: selectorStep3(state, "customDiscounts"),
    weekendPriceValue: selectorStep3(state, "weekendPrice"),
});

const mapDispatch = {};

export default injectIntl(
    withStyles(s, bt)(connect(mapState, mapDispatch)(Pricing))
);
